module.exports = __webpack_public_path__ + "img/zxcTitle1.3529eece.png";